<template>
  <div class="warning">
    <img class="img" src="../../assets/dash/dash-icon1.png" alt="" />
    <div class="title">
      <div class="ti_head">
        <div class="peak_title">
          <img class="peak_img" src="../../assets/dash/dash-icon8.png" alt="" />
          <div class="peak_text">近期预警信息</div>
        </div>
        <div class="ti_sx" @click="onSX">刷新</div>
      </div>
      <div class="list">
        <div class="list_head">
          <div
            class="head_li"
            style="justify-content: flex-start; padding-left: 0.8rem"
          >
            车牌号
          </div>
          <div class="head_li" style="position: relative" @click="onTagsShow">
            {{ warningType ? warningType : "全部预警" }}
            <div class="arrow-down"></div>
            <div class="tags" v-if="tags">
              <div class="tags_title" @click="ontags(1)">超时预警</div>
              <div class="tags_title" @click="ontags(2)">途径点预警</div>
              <div class="tags_title" @click="ontags(3)">
                途径点预警/超时预警
              </div>
            </div>
          </div>
          <div class="head_li" @click="onTime">
            预警时间
            <div class="arrow-down"></div>
          </div>
          <div
            class="head_li"
            style="padding-right: 0.8rem; justify-content: flex-end; width: 20%"
            @click="onTagsHs"
          >
            {{ verify }}
            <div class="arrow-down"></div>
            <div class="tags_hs" v-if="tagsHs">
              <div class="tags_title" @click="gettagsHs(1)">已核实</div>
              <div class="tags_title" @click="gettagsHs(0)">未核实</div>
            </div>
          </div>
        </div>
        <div class="noTitle" v-if="lists.length == 0">暂无预警信息</div>
        <div
          class="list_head"
          v-for="(item, index) in lists"
          :key="index"
          :style="{
            backgroundColor: index % 2 === 1 ? '#f3f9ff' : 'transparent',
          }"
        >
          <div
            class="head_li_c"
            style="justify-content: flex-start; padding-left: 0.8rem"
            @click="onPlateNumber(item.id)"
          >
            {{ item.plateNumber }}
          </div>
          <div class="head_li_c">{{ item.warningType }}</div>
          <div class="head_li_c">{{ handleTime(item.createTime) }}</div>
          <div
            class="head_li_c"
            style="justify-content: flex-end; padding-right: 0.8rem; width: 20%"
          >
            {{ item.verifyStatus === 0 ? "未核实" : "已核实" }}
          </div>
        </div>
      </div>
    </div>
    <!-- 核实时间 -->
    <van-popup v-model="show" position="bottom" :style="{ height: '30%' }">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        :title="title"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="show = false"
      />
    </van-popup>
    <!-- 添加加载动画 -->
    <div class="loading-animation" v-if="loading">
      <van-loading size="24px">加载中...</van-loading>
    </div>
    <div class="Gotop" @click="onTop" v-if="topShow">回到顶部</div>
    <div class="bot_title">版权所有：陕西关山草原旅游发展有限责任公司</div>
  </div>
</template>
<script>
import request from "@/api/index";
export default {
  data() {
    return {
      lists: [],
      code: "", //授权返回的code
      tags: false,
      tagsHs: false,
      minDate: "",
      maxDate: "",
      currentDate: new Date(),
      title: "选择开始时间",
      startTime: "",
      endTime: "",
      show: false,
      warningType: "", //预警类型
      warning: "全部预警",
      verifyStatus: "", //核实状态
      verify: "未核实",
      pageSize: 20,
      pageNum: 1,
      openId: "",
      addList: false, //是否加载下一页
      topShow: false, //是否展示回到顶部
      loading: false, // 加载状态
      scrollListener: null,
      // 存储滚动监听器
    };
  },
  async mounted() {
    const _this = this;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code"); // 成功获取code
    this.code = code ? code : "";
    const opens = localStorage.getItem("openid");
    if (opens) {
      _this.openId = opens;
      this.getList();
    } else {
      if (this.code) {
        const res = await request.wxcode(this.code);
        localStorage.setItem("openid", res.data.openId);
        this.openId = res.data.openId;
        this.getList();
      } else {
        this.$router.push({
          path: "/login",
          query: {
            url: window.location.href,
          },
        });
      }
    }
    // 添加滚动监听，使用命名函数以便于移除
    this.scrollListener = this.handleScroll.bind(this);
    window.addEventListener("scroll", this.scrollListener);
  },
  // 添加 beforeDestroy 钩子移除监听
  beforeDestroy() {
    if (this.scrollListener) {
      window.removeEventListener("scroll", this.scrollListener);
    }
  },

  methods: {
    // 提取滚动处理逻辑为单独方法
    handleScroll() {
      // 获取当前滚动位置
      const scrollPosition = window.scrollY || window.pageYOffset;
      // 获取整个文档的高度
      const documentHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.body.clientHeight,
        document.documentElement.clientHeight
      );
      // 获取视口高度
      const windowHeight =
        window.innerHeight || document.documentElement.clientHeight;
      // 计算距离底部的距离
      const distanceToBottom = documentHeight - (scrollPosition + windowHeight);
      // 当接近底部时执行操作
      if (distanceToBottom < 200 && !this.loading && !this.addList) {
        this.loadMore();
      }
      // 显示回到顶部按钮
      this.topShow = scrollPosition > 500;
    },
    // 加载更多数据
    async loadMore() {
      this.loading = true;
      this.pageNum++;
      await this.getList();
      this.loading = false;
    },
    //刷新
    onSX() {
      this.lists = [];
      this.pageNum = 1;
      this.warningType = "";
      this.verifyStatus = "";
      this.startTime = "";
      this.endTime = "";
      this.pageSize = 20;
      this.title = "选择开始时间";
      this.tags = false;
      this.tagsHs = false;
      this.verify = "未核实";
      this.getList();
    },
    //点击车牌号
    onPlateNumber(id) {
      //地址跳转
      // const baseUrl = window.location.origin + window.location.pathname;
      // const newUrl = `${baseUrl}?warningId=${id}#/`;
      // window.location.href = newUrl;
      //路由跳转
      this.$router.push({
        path: "/",
        query: {
          warningId: id,
        },
      });
    },
    //一键回到顶部
    onTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth", // 平滑滚动
      });
      this.topShow = false;
    },
    //处理时间
    handleTime(time) {
      if (time) {
        return time.includes("T")
          ? time.split("T")[0] + " " + time.split("T")[1]
          : time;
      }
      // return time;
    },
    onTime() {
      this.show = true;
      this.tags = false;
      this.tagsHs = false;
      const currentDate = new Date(); // 当前日期
      const maxDate = new Date(currentDate);
      console.log(
        maxDate.setDate(currentDate.getDate() - 7),
        new Date(2025, 0, 1)
      );
      this.minDate = new Date(maxDate.setDate(currentDate.getDate() - 7));
      this.maxDate = new Date();
    },
    onConfirm(value) {
      // 处理确认事件
      console.log("选中的时间:", value);
      const date = new Date(value);
      // 获取各个部分
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // 月份从0开始
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      const formatted1 = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")} ${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
      console.log("格式化后的日期和时间:", formatted1);
      console.log(new Date());
      if (this.startTime) {
        this.endTime = formatted1;
        this.show = false;
        this.lists = [];
        this.pageNum = 1;
        this.getList();
        this.title = "选择开始时间";
      } else {
        this.startTime = formatted1;
        this.title = "选择结束时间";
      }
    },
    //预警信息
    onTagsShow() {
      this.tags = !this.tags;
      this.tagsHs = false;
    },

    ontags(index) {
      console.log(index);
      if (index == 1) {
        this.warningType = "超时预警";
        this.tags = !this.tags;
        this.lists = [];
        this.pageNum = 1;
        this.getList();
        this.tags = !this.tags;
      }
      if (index == 2) {
        this.warningType = "途径点预警";
        this.tags = !this.tags;
        this.lists = [];
        this.pageNum = 1;
        this.getList();
        this.tags = !this.tags;
      }
      if (index == 3) {
        this.warningType = "途径点预警/超时预警";
        this.tags = !this.tags;
        this.lists = [];
        this.pageNum = 1;
        this.getList();
        this.tags = !this.tags;
      }
    },
    //核实
    onTagsHs() {
      this.tagsHs = !this.tagsHs;
      this.tags = false;
    },
    gettagsHs(index) {
      if (index == 1) {
        this.verifyStatus = index;
        this.tagsHs = !this.tagsHs;
        this.lists = [];
        this.pageNum = 1;
        this.verify = "已核实";
        this.getList();
        this.tagsHs = !this.tagsHs;
      }
      if (index == 0) {
        this.verifyStatus = index;
        this.tagsHs = !this.tagsHs;
        this.lists = [];
        this.pageNum = 1;
        this.verify = "未核实";
        this.getList();
        this.tagsHs = !this.tagsHs;
      }
    },
    //获取数据
    async getList() {
      const data = {
        plateNumber: "",
        warningType: this.warningType,
        verifyStatus: this.verifyStatus,
        startTime: this.startTime,
        endTime: this.endTime,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        openId: this.openId,
      };
      console.log(data);

      const res = await request.getvehicle(data);
      console.log(res.data.data);
      this.lists = [...this.lists, ...res.data.data.list];
      if (res.data.data.list.length < this.pageSize) {
        this.addList = true;
      }
    },
  },
  watch: {
    //监听屏幕高度
  },
};
</script>
<style scoped>
@import "Warning.css";
</style>